import { render, staticRenderFns } from "./CardDescriptionPlan.vue?vue&type=template&id=1079284a"
import script from "./CardDescriptionPlan.vue?vue&type=script&lang=js"
export * from "./CardDescriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./CardDescriptionPlan.vue?vue&type=style&index=0&id=1079284a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1079284a')) {
      api.createRecord('1079284a', component.options)
    } else {
      api.reload('1079284a', component.options)
    }
    module.hot.accept("./CardDescriptionPlan.vue?vue&type=template&id=1079284a", function () {
      api.rerender('1079284a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/details/components/CardDescriptionPlan.vue"
export default component.exports